import React from 'react';
import Article from '../../components/article/Article';
import { blog01, blog02, blog03, blog04, blog05 } from './imports';
import './blog.css';

const Blog = () => (
  <div className="gpt3__blog section__padding" id="blog">
    <div className="gpt3__blog-heading">
      <h1 className="gradient__text">A lot is happening, <br /> We are blogging about it.</h1>
    </div>
    <div className="gpt3__blog-container">
      <div className="gpt3__blog-container_groupA">
        <Article imgUrl={blog01} date="June 26, 2023" text="AICORP & VirtualVerse AI is the future. Let us exlore how it is?" />
      </div>
      <div className="gpt3__blog-container_groupB">
        <Article imgUrl={blog02} date="June 16, 2023" text="AI Avatars and Virtual Influencers: The Future of Social Media Marketing?" />
        <Article imgUrl={blog03} date="June 20, 2023" text="Empowering Communication: How AI Avatars Enhance Social Inclusion" />
        <Article imgUrl={blog04} date="June 28, 2023" text="Privacy and Security Considerations with AI Avatars on Social Media" />
        <Article imgUrl={blog05} date="July 06, 2023" text="The Future of AI Avatars: Innovations and Possibilities" />
      </div>
    </div>
  </div>
);

export default Blog;
